module.exports = __webpack_public_path__ + "src/images/ongc.c981a5b9c25c21761cd68c8679ae7952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ongc.jpg
// module id = 117
// module chunks = 0